import * as Cl from '@design-system/component-library';
import { type JSX, useEffect } from 'react';
import { FormProvider, useForm, useWatch } from 'react-hook-form';
import { dsClass } from '../../common/constants/dsClasses.js';
import {
  reasonToRejectErrorMsg,
  reasonToRejectMsg,
  t,
  thankYouRejectQuoteDescriptionMsg,
  thankYouRejectQuoteMsg,
} from '../../common/i18n/index.js';
import { TextAreaComponent } from '../../common/react-hook-form/components/TextAreaComponent.js';

import './RejectQuoteModalContentCoCo.scss';

type RejectQuoteFormValues = {
  rejectionReason: string;
};

export const RejectQuoteModalContentCoCo = ({
  onReasonChange,
  showReasonRequiredError,
}: {
  onReasonChange: (value: string) => void;
  showReasonRequiredError: boolean;
}): JSX.Element => {
  const methods = useForm<RejectQuoteFormValues>({
    defaultValues: {
      rejectionReason: '',
    },
    mode: 'onChange',
  });

  const watchedReason = useWatch({
    control: methods.control,
    name: 'rejectionReason',
  });

  useEffect(() => {
    const nextReason = watchedReason || '';
    onReasonChange(nextReason);
  }, [watchedReason, onReasonChange]);

  return (
    <>
      <div>{t.H131(thankYouRejectQuoteMsg)}</div>
      <div className={dsClass.PADDING_TOP_4}>{t.B63L(thankYouRejectQuoteDescriptionMsg)}</div>
      <FormProvider {...methods}>
        <div className={`${dsClass.PADDING_TOP_4} ${showReasonRequiredError ? 'reject-quote-error' : ''}`}>
          <TextAreaComponent
            disabled={false}
            name="rejectionReason"
            label={t.H7VQ(reasonToRejectMsg)}
            required={true}
            rows={4}
          />
        </div>
        {showReasonRequiredError && <Cl.InputError>{t.OLP6(reasonToRejectErrorMsg)}</Cl.InputError>}
      </FormProvider>
    </>
  );
};
